// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/accolades-list-simple/accolades-list-simple.component.scss
// module id = 514
// module chunks = 0